import { render, staticRenderFns } from "./category_edit.vue?vue&type=template&id=01d31a98&"
import script from "./category_edit.vue?vue&type=script&lang=ts&"
export * from "./category_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports